import { gql } from "@apollo/client";

export const GetPending = gql`
  query pendingUser($orgId: String, $token: String) {
    pendingUser(orgId: $orgId, token: $token)
  }
`;
